import { render, staticRenderFns } from "./GroupsHeader.vue?vue&type=template&id=0a85debc&scoped=true&"
import script from "./GroupsHeader.vue?vue&type=script&lang=ts&"
export * from "./GroupsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsHeader.vue?vue&type=style&index=0&id=0a85debc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a85debc",
  null
  
)

export default component.exports